/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ConsigneeDeliveryNotesArrayResponseV3 } from '../models/consignee-delivery-notes-array-response-v-3';
import { getConsigneeAddonsDeliveryNotesV3 } from '../fn/delivery-notes-v-3/get-consignee-addons-delivery-notes-v-3';
import { GetConsigneeAddonsDeliveryNotesV3$Params } from '../fn/delivery-notes-v-3/get-consignee-addons-delivery-notes-v-3';

@Injectable({ providedIn: 'root' })
export class DeliveryNotesV3Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getConsigneeAddonsDeliveryNotesV3()` */
  static readonly GetConsigneeAddonsDeliveryNotesV3Path = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/';

  /**
   * Get consignee delivery notes (v3).
   *
   * Get delivery notes for consignee with enhanced pagination and sorting.
   * Supports improved performance with pagination parameters.
   * Can fetch delivery notes from multiple sites using the organizationSiteKeys query parameter.
   * Now, the orderNumber (from v2) can be passed via the filter property.
   * All filters (filterProperty/filterValue, direct field filters, search) are
   * passed through to the basic backend.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsigneeAddonsDeliveryNotesV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeAddonsDeliveryNotesV3$Response(params: GetConsigneeAddonsDeliveryNotesV3$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsigneeDeliveryNotesArrayResponseV3>> {
    const obs = getConsigneeAddonsDeliveryNotesV3(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get consignee delivery notes (v3).
   *
   * Get delivery notes for consignee with enhanced pagination and sorting.
   * Supports improved performance with pagination parameters.
   * Can fetch delivery notes from multiple sites using the organizationSiteKeys query parameter.
   * Now, the orderNumber (from v2) can be passed via the filter property.
   * All filters (filterProperty/filterValue, direct field filters, search) are
   * passed through to the basic backend.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsigneeAddonsDeliveryNotesV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeAddonsDeliveryNotesV3(params: GetConsigneeAddonsDeliveryNotesV3$Params, context?: HttpContext): Observable<ConsigneeDeliveryNotesArrayResponseV3> {
    const resp = this.getConsigneeAddonsDeliveryNotesV3$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ConsigneeDeliveryNotesArrayResponseV3>): ConsigneeDeliveryNotesArrayResponseV3 => r.body)
    );
  }

}
